import Helpers from "../../helpers/helpers";
import { server } from "../globalSettings";

export const requestAuthOption = (method, data) => {
    let token = JSON.parse(localStorage.getItem("token"));

    let headers = {
        Authorization: `Bearer ${token}`,
    };

    // If data is NOT FormData, set Content-Type to application/json
    if (!(data instanceof FormData)) {
        headers['Content-Type'] = 'application/json';
    }

    const requestOptions = {
        method: method,
        headers: headers,
        body: data instanceof FormData ? data : JSON.stringify(data)
    };

    return requestOptions;
};

// api
export const userListingApi = async (payload) => {
    let department_ids = '';
    let team_ids = '';
    if (payload?.department_id?.length > 0) {
        department_ids = payload.department_id.map(id => `filter[department_id][]=${encodeURIComponent(id)}`).join('&');
    }

    if (payload?.team_id?.length > 0) {
        team_ids = payload.team_id.map(id => `filter[team_id][]=${encodeURIComponent(id)}`).join('&');
    }
    const request = requestAuthOption("GET")
    try {
        const response = await fetch(`${server}user?sort_order=${payload?.sort}&sort=${payload?.sort_by}&size=${payload?.length}&search=${payload?.keyword}&paginate=${payload?.page}&type=${payload?.type || ""}&role[]=${payload?.role_id || ""}${department_ids ? '&' + department_ids : ''}${team_ids ? '&' + team_ids : ''}`, request);
        const data = await response.json();
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                if (response.ok) {
                    if (data.code === "success") {
                        resolve(data.data);
                    } else {
                        reject(["No data"]);
                    }
                } else {
                    if (data?.code === "login_needed" || data?.code === "unauthenticated") {
                        Helpers.routeToLogin();
                    }
                    reject(["Something went wrong, please try again later"]);
                }
            });
        });
        // if (response.ok) {
        //     const data = await response.json(); // Parse JSON data
        //     if (data.code === "success") {
        //         return data; // Return the data
        //     } else {
        //         apiError("Username and password are invalid. Please enter correct username and password");
        //         return false; // Custom error message
        //     }
        // } else {
        //     throw new Error('Network response was not ok');
        // }
    } catch (error) {
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                reject(["Network response error, please try again later"]);
                // throw error;
            })
        })

    }
};

export const userDetailsApi = async (payload) => {
    const request = requestAuthOption("GET")
    try {
        const response = await fetch(`${server}${payload?.type}/${payload?.id}`, request);
        const data = await response.json();
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                if (response.ok) {
                    if (data.code === "success") {
                        resolve(data.data);
                    } else if (data.code === "invalid field") {
                        reject(["No data"]);
                    }
                } else {
                    if (data?.code === "login_needed" || data?.code === "unauthenticated") {
                        Helpers.routeToLogin();
                    }
                    reject(["Something went wrong, please try again later"]);
                }
            });
        });
    } catch (error) {
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                reject(["Network response error, please try again later"]);
                // throw error;
            })
        })

    }
};

export const addNewUser = async (payload) => {
    const request = requestAuthOption("POST", payload?.data)
    try {
        const response = await fetch(`${server}user/${payload?.userType || ""}`, request);
        const data = await response.json();
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                if (response.ok) {
                    if (data.code === "success") {
                        resolve(data);
                    } else {
                        reject(data);
                    }
                } else {
                    if (data?.code === "login_needed" || data?.code === "unauthenticated") {
                        Helpers.routeToLogin();
                    }
                    reject(["Something went wrong, please try again later"]);
                }
            });
        });
    } catch (error) {
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                reject(["Network response error, please try again later"]);
                // throw error;
            })
        })

    }
};

export const delUser = async (payload) => {
    let request = requestAuthOption("DELETE");
    try {
        const response = await fetch(`${server}${payload?.userType}/${payload?.id}`, request)
        const data = await response.json();
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                if (response.ok) {
                    if (data.code === "success") {
                        resolve(data);
                    } else {
                        reject(data);
                    }
                } else {
                    if (data?.code === "login_needed" || data?.code === "unauthenticated") {
                        Helpers.routeToLogin();
                    }
                    resolve({ data: data, api: payload?.api });
                }
            });
        });
    } catch (error) {
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                reject(["Network response error, please try again later"]);
                // throw error;
            })
        })

    }
};
export const updateUser = async (payload) => {
    const request = requestAuthOption("PUT", payload?.data)
    try {
        const response = await fetch(`${server}user/${payload?.userType}/${payload?.id}`, request);
        const data = await response.json();
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                if (response.ok) {
                    if (data.code === "success") {
                        resolve(data);
                    } else {
                        reject(data);
                    }
                } else {
                    if (data?.code === "login_needed" || data?.code === "unauthenticated") {
                        Helpers.routeToLogin();
                    }
                    reject(["Something went wrong, please try again later"]);
                }
            });
        });
    } catch (error) {
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                reject(["Network response error, please try again later"]);
                // throw error;
            })
        })

    }
};

export const updateActivationUser = async (payload) => {
    const request = requestAuthOption("PUT", payload?.data)
    try {
        const response = await fetch(`${server}user/${payload?.userType}/${payload?.id}/${payload?.action || ""}`, request);
        const data = await response.json();
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                if (response.ok) {
                    if (data.code === "success") {
                        resolve(data);
                    } else if (data.code === "validation_failed") {
                        reject([data.errors]);
                        resolve(data.errors);
                    }
                } else {
                    if (data?.code === "login_needed" || data?.code === "unauthenticated") {
                        Helpers.routeToLogin();
                    }
                    reject(["Something went wrong, please try again later"]);
                }
            });
        });
    } catch (error) {
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                reject(["Network response error, please try again later"]);
                // throw error;
            })
        })

    }
};

export const updateDepartmentUser = async (payload) => {
    const request = requestAuthOption("PUT", payload?.data)
    try {
        const response = await fetch(`${server}member/${payload?.id}/department`, request);
        const data = await response.json();
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                if (response.ok) {
                    if (data.code === "success") {
                        resolve(data);
                    } else if (data.code === "validation_failed") {
                        reject([data.errors]);
                        resolve(data.errors);
                    }
                } else {
                    if (data?.code === "login_needed" || data?.code === "unauthenticated") {
                        Helpers.routeToLogin();
                    }
                    reject(["Something went wrong, please try again later"]);
                }
            });
        });
    } catch (error) {
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                reject(["Network response error, please try again later"]);
                // throw error;
            })
        })

    }
};

export const exportAdmin = async (payload) => {
    let department_ids = '';
    let team_ids = '';
    if (payload?.department_id?.length > 0) {
        department_ids = payload.department_id.map(id => `filter[department_id][]=${encodeURIComponent(id)}`).join('&');
    }

    if (payload?.team_id?.length > 0) {
        team_ids = payload.team_id.map(id => `filter[team_id][]=${encodeURIComponent(id)}`).join('&');
    }

    const request = requestAuthOption("POST")
    try {
        const response = await fetch(`${server}${payload?.type}/export?sort_order=${payload?.sort}&sort=${payload?.sort_by}&search=${payload?.keyword}&role[]=${payload?.role_id || ""}${department_ids ? '&' + department_ids : ''}${team_ids ? '&' + team_ids : ''}`, request);
        const data = await response.json();
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                if (response.ok) {
                    if (data.code === "success") {
                        resolve(data);
                    } else {
                        reject([data.errors]);
                        resolve(data.errors);
                    }
                } else {
                    if (data?.code === "login_needed" || data?.code === "unauthenticated") {
                        Helpers.routeToLogin();
                    }
                    reject(["Something went wrong, please try again later"]);
                }
            });
        });
    } catch (error) {

        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                reject(["Network response error, please try again later"]);
                // throw error;
            })
        })

    }
};

